import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ui-promotions',
  templateUrl: './promotions.component.html',
  styleUrls: ['./promotions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class PromotionsComponent {
}
